import { Box, Typography } from '@mui/material';

export const EnvBanner = (props: { color: string; text: string }) => {
  const { color, text } = props;
  return (
    <Box
      color='white'
      sx={{ width: '100%', backgroundColor: color, textAlign: 'center' }}
    >
      <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
        {text}
      </Typography>
    </Box>
  );
};
